module.exports = __webpack_public_path__ + "img/red_047.68b9b7be.png";